import React from 'react'

const ProductLabel = ({ state, unitPrice, currency }) => {

    return (
        <div className='text-sm flex gap-x-2 items-center'>
            {state ? `${state?.collectionName}${state?.color ? `, ${state.color.code}, ${state.color.name}` : ""}${state?.weight ? `, ${state.weight.code}, ${state.weight.name}` : ""}${state?.pattern ? `, ${state.pattern.code}, ${state.pattern.name}` : ""}` : ""}
            {unitPrice && <span className='bg-green-700 text-xs px-2 py-1 rounded-full text-white whitespace-nowrap'>{unitPrice} {currency}/m </span>}
        </div>
    )
}

export default ProductLabel